import { react2angular } from 'react2angular';

import ConditionMonitoringView from "./ConditionMonitoringView";

// TODO webtip.module is needed for React to render for some reason - move to correct module
angular.module('webtip.module')
    .component('conditionMonitoringView', react2angular(ConditionMonitoringView,[],
        ['ConditionService', 'fleetService', 'userService', 'userViewService', 'bearingConditionExportService', '$uibModal', '$state', '__env']));
